import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import Demands from '@app/pages/carrier/demand-list/Demands.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const PageDemands = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t('Demands.demands', 'Poptávky')}>
      {/*// @ts-ignore*/}

      <Card>
        <Demands />
      </Card>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(PageDemands);
